export default __webpack_public_path__ + "static/media/new.86f03dd3.svg";